__turbopack_context__.v({
  "cardsWrapper": "checkYourRateCard-module-scss-module__wKEJNa__cardsWrapper",
  "inputWrapper": "checkYourRateCard-module-scss-module__wKEJNa__inputWrapper",
  "subTitle": "checkYourRateCard-module-scss-module__wKEJNa__subTitle",
  "title": "checkYourRateCard-module-scss-module__wKEJNa__title",
});
